import React from 'react';
import { Menu, Button } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { HomeTabKeyEnum } from '../utils';

const BookmarksContainer = styled.div`
  .ant-dropdown-menu {
    max-height: 400px;
    overflow-y: auto;
  }
`;

const ManageButton = styled(Button)`
  margin-top: 10px;
  width: 100%;
`;

const BookmarksMenu = ({ bookmarks  }: any) => {
  const navigate = useNavigate();
    
  const renderMenuItems = (items: any, selectedKeys: string[] = []) => {
    return items
      ?.map((item: any) => {
        const isSelected = selectedKeys.includes(item.id);
        if (item.type === "folder") {
          return {
            key: item.id,
            label: (
              <span>
                <FolderOutlined
                  style={{
                    marginRight: "8px",
                    fontSize: "16px",
                    color: isSelected ? "#5f6368" : "#5f6368",
                  }}
                />
                {item.title}
              </span>
            ),
            children: renderMenuItems(item.children, selectedKeys),
          };
        } else if (item.type === "bookmark") {
          return {
            key: item.id,
            label: (
              <span>
                <img
                  src={(() => {
                    const url = item.url;
                    let updatedUrl: URL | string = "";
                    try {
                      updatedUrl = url ? new URL(url).hostname : "";
                    } catch (error) {
                      console.log("Invalid URL:", url, error);
                    }
                    return `https://www.google.com/s2/favicons?domain=${updatedUrl}`;
                  })()}
                  alt=""
                  style={{ marginRight: "8px", width: "16px", height: "16px" }}
                />
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.title}
                </a>
              </span>
            ),
          };
        }
        return null;
      })
      .filter((item: any) => item !== null);
  };

  // Example: Track selected keys
  const [selectedKeys, setSelectedKeys] = React.useState<string[]>([]);

  // Filter out the root folder (id: "1") and use its children
  const rootFolder = Array.isArray(bookmarks) 
    ? bookmarks.find((item: any) => item.id === "1") 
    : bookmarks.id === "1" ? bookmarks : null;
  const menuItems = rootFolder?.children 
    ? renderMenuItems(rootFolder.children, selectedKeys) 
    : renderMenuItems(bookmarks, selectedKeys);

  return (
    <BookmarksContainer>
      <Menu
        style={{ width: 250 }}
        mode="vertical"
        items={menuItems}
        selectedKeys={selectedKeys}
        onClick={({ key }) => setSelectedKeys([key])}
      />
      <ManageButton type="primary" onClick={() => navigate(HomeTabKeyEnum.BOOKMARK)}>
        Manage Bookmarks
    </ManageButton>
    </BookmarksContainer>
  );
};

export default BookmarksMenu;